"use client";

import Link from "@/components/link/link";
import { SupportedLocale } from "@/lib/i18n/locales";
import { getSupportCopy } from "@/lib/i18n/support";

type SupportProps = {
  locale: SupportedLocale;
};

const Support = ({ locale }: SupportProps) => {
  const copy = getSupportCopy(locale);

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mx-auto max-w-xl space-y-6 text-left">
        <h1 className="text-xl font-bold">{copy.title}</h1>
        <p>{copy.intro}</p>

        <div className="space-y-1">
          <p className="font-semibold">{copy.emailLabel}</p>
          <Link href="mailto:info@videototextai.com">info@videototextai.com</Link>
        </div>

        <div className="space-y-1">
          <p className="font-semibold">{copy.discordLabel}</p>
          <Link href="https://discord.gg/Q8CFWVmZxh" target="_blank">
            {copy.discordCta}
          </Link>
        </div>
      </div>
    </div>
  );
};

export { Support };
